export const lng = {
					"bg": {
						"role": "en",
						"img": "assets/images/en.svg",
						"tooltipText": "English",
						"aboutUs": "За нас",
						"prices": "Цени",
						"blog": "Блог",
						"contacts": "Контакти",
						"touch": "Свържете се с нас",
						"offers": "Виж офертите",
						"contactUs": "Свържете се с експерт",
						"offer1": "от 300 &euro;",
						"offer2": "от 500 &euro;",
						"offer3": "от 700 &euro;",
						"offer4": "от 900 &euro;",
						"offer1euro": "",
						"offer2euro": "",
						"offer3euro": "",
						"offer4euro": "",
						"personal": "Индивидуално решение, създадено за вас",
						"searchPackage": "Не намирате пакет, който ви пасва напълно?",
						"uniqueProjects": "Всеки проект при нас е уникален. Можем да комбинираме елементи от различни пакети или да създадем изцяло нова оферта, съобразена с вашите цели, функционалности и бюджет.",
						"ourProjects": "Наши проекти",
						"ourProjectsText": "Всяка реализация е резултат от индивидуален подход, ясна комуникация и високи стандарти. Вижте част от проектите, които сме създали за наши клиенти и партньори.",
						"followUs": "Последвайте ни в социалните мрежи:",
						"useContact": "Използвайте контактната форма, за да споделите своите въпроси, предложения или мнения. <br> Ние ценим всяка обратна връзка, тя ни помага да бъдем още по-добри.",
						"send": "Изпрати",
						"inquiry": "Запитване",
						"phone": "Телефонен номер",
						"yourName": "Вашето име",
						"mb0": "Copyright &copy; 2025 Векота ЕООД, Всички права запазени.<br> Изработено от Векота.",
						"noWasteTime": "Не отлагайте, успехът започва сега.",
						"haveQuestions": "Имате въпроси?",
						"suggestions": "Имате въпроси, идеи или просто искате да ни пишете?",
						"whyUs": "Защо да се доверите на нас?",
						"callUs": "разкажете ни",
						"writeUs": "пишете ни",
						"quickly": "Бързо. Надеждно. Достъпно.",
						"head1": "Сайтове и софтуер,",
						"head2": "които работят за вашия бизнес.",
						"content1": "Независимо дали търсите онлайн магазин, корпоративен уебсайт или персонализиран софтуер – ние ще ви помогнем да го реализирате. <br> Разгледайте нашите готови предложения или се свържете с нас за индивидуално решение, съобразено с вашите цели и бюджет.",
						"offersPackages": "Пакети, създадени с мисъл за бизнеса ви",
						"whyContent1": "Предлагаме оптимално съотношение между цена и качество, без компромис с резултатите.",
						"why1": "Конкурентни цени",
						"whyContent2": "Работим открито и отговорно. Вярваме, че доверието е основата на дългосрочно партньорство.",
						"why2": "Коректност и прозрачност",
						"whyContent3": "Споделете с нас вашите идеи. Ние ще ви дадем експертни насоки и варианти за реализация, без ангажимент.",
						"why3": "Безплатна консултация",
						"whyContent4": "Създаваме уебсайтове и софтуер по мярка: статични, динамични или онлайн магазини, съобразени с нуждите ви.",
						"why4": "Персонализирана изработка",
						"whyContent5": "Вашият сайт ще изглежда отлично на всяко устройство. Адаптивна визия и дизайн, отразяващ вашата идентичност.",
						"why5": "Модерен дизайн",
						"whyContent6": "Всеки детайл е прецизно изграден, така че сайтът ви не просто да изглежда добре, а да работи безупречно.",
						"why6": "Функционалност без компромиси",
						"whatNeed": "Кажете ни от какво имате нужда",
						"sentMessage": "Вашето запитване беше изпратено успешно!",
						"partner1": "Център за психологическа подкрепа \"Петра\"",
						"partner2": "Онлайн-магазин за разсади",
						"partner3": "Официален сайт на БК ЦСКА",
						"partner23": "Почистване на домове и офиси",
						"partner24": "Официален сайт на BNI Pro",
						"partner25": "Сайт на Щерев Консулт",
						"partner27": "Сайт на Codwise Fulfillment",
						"partner26": "Сайт на Euro fulfillment",
						"partner4": "Бранд на Адриана Иванова",
						"partner5": "Танцова школа \"Слънчева агенция\"",
						"partner6": "Сайт за новини, публицистика и култура",
						"partner7": "CRM система на Max Group Events",
						"partner8": "Онлайн магазин за цветя и растения",
						"partner9": "Сайт за преградни стени и wc кабини",
						"partner10": "Държавна агенция за закрила на детето",
						"partner11": "Туристическа агенция \"Блу Брийз Травел\"",
						"partner12": "Правен съветник по недвижими имоти Мартина Петкова",
						"partner13": "ВИТ - борсата за матраци",
						"partner14": "Организационна система на счетоводна къща АВМ Консултинг Груп",
						"partner15": "API интеграция за мобилно приложение Cyberkidz Patrol",
						"partner16": "Мистър Сенков ЕООД - строителни ремонти и довършителни работи",
						"reviews": "Отзиви",
						"errName": "Име трябва да е минимум 3 символа!",
						"errEmail": "Невалиден имейл адрес!",
						"errInquire": "Запитването трябва да е минимум 10 символа!",
						"makeAnInquiry": "направи запитване",
						"static": "статичен сайт",
						"noStatic": "динамичен сайт",
						"to5": "до 5 страници",
						"to15": "до 15 страници",
						"unlimited": "неограничен брой страници",
						"oneLanguage": "само една езикова версия",
						"multiLanguage": "възможност за няколко езикови версии",
						"seo": "SEO оптимизация",
						"ssl": "SSL сертификат",
						"managament": "админ панел за частично менажиране на съдържанието",
						"fullManagament": "админ панел за менажиране на съдържанието",
						"name1": "Орлин Матеев",
						"name2": "Стоянка Стоичкова",
						"position1": "съосновател и управител",
						"position2": "мениджър проекти",
						"sentSuccess": "Запитването беше изпратено успешно!"
					},
					"en": {
						"role": "bg",
						"img": "assets/images/bg.svg",
						"tooltipText": "Български",
						"aboutUs": "About us",
						"prices": "Prices",
						"blog": "Blog",
						"contacts": "Contacts",
						"touch": "Get in Touch",
						"offers": "View Offers",
						"contactUs": "Contact an Expert",
						"offer1": "from 300 &euro;",
						"offer2": "from 500 &euro;",
						"offer3": "from 700 &euro;",
						"offer4": "from 900 &euro;",
						"offer1euro": "",
						"offer2euro": "",
						"offer3euro": "",
						"offer4euro": "",
						"personal": "Custom Solution, Tailored to You",
						"searchPackage": "Can’t Find the Perfect Match?",
						"uniqueProjects": "Every project we build is unique. We can mix and match features from different packages or create a fully custom plan based on your needs, goals, and budget.",
						"ourProjects": "Our projects",
						"ourProjectsText": "Every project we complete reflects our commitment to quality, clarity and a personalised approach. Explore a selection of websites we have built for our clients and partners.",
						"followUs": "Follow us on social media:",
						"useContact": "Use our contact form to send us your questions, suggestions, or feedback. <br> We truly value every message. Your input helps us grow and serve you better.",
						"send": "Send",
						"inquiry": "Inquiry",
						"phone": "Phone number",
						"yourName": "Your name",
						"mb0": "Copyright &copy; 2025 Vekota LTD, All rights reserved.<br> Powered by Vekota.",
						"noWasteTime": "Don’t wait, your digital success starts now.",
						"haveQuestions": "Have questions?",
						"suggestions": "Have Questions, Ideas or Just Want to Say Hello?",
						"whyUs": "Why Choose Us?",
						"callUs": "Tell Us More",
						"writeUs": "Message Us",
						"quickly": "Fast. Reliable. Affordable.",
						"head1": "Websites and Software",
						"head2": "That Work for Your Business.",
						"content1": "Whether you need an online store, a corporate website or custom-built software, we are here to bring your idea to life. <br> Browse our packages or get in touch for a tailor made solution that fits your goals and budget.",
						"offersPackages": "Plans Designed with Your Business in Mind",
						"whyContent1": "We offer the best balance between quality and affordability without compromising results.",
						"why1": "Competitive Pricing",
						"whyContent2": "We believe trust is the foundation of any successful partnership. That’s why we work with integrity and clear communication.",
						"why2": "Honesty and Transparency",
						"whyContent3": "Share your ideas with us and we will provide expert guidance and practical suggestions at no cost, with no obligations.",
						"why3": "Free Consultation",
						"whyContent4": "Whether you need a static site, a dynamic platform or an online store, we build solutions tailored to your needs.",
						"why4": "Custom Development",
						"whyContent5": "Your website will look stunning on any device with a responsive layout that reflects your brand.",
						"why5": "Modern Design",
						"whyContent6": "Every feature is crafted with precision, ensuring your site not only looks great but performs seamlessly.",
						"why6": "Flawless Functionality",
						"whatNeed": "Tell us what you’re looking for",
						"sentMessage": "Your message was sent successfully!",
						"partner1": "Psychological Support Center \"Petra\"",
						"partner2": "E-shop for seedlings",
						"partner3": "Official website of BC CSKA",
						"partner23": "Cleaning of homes and offices",
						"partner24": "Official website of BNI Pro",
						"partner25": "Website of Shterev Consult",
						"partner26": "Website of Euro fulfillment",
						"partner27": "Сайт на Codwise Fulfillment",
						"partner4": "Adriana Ivanova's brand",
						"partner5": "Dance school \"Sunny agency\"",
						"partner6": "News, journalism and culture website",
						"errName": "Name must be at least 3 characters long!",
						"partner7": "CRM system of Max Group Events LTD",
						"partner8": "E-shop for flowers and plants",
						"partner9": "Partition walls and toilet cubicles",
						"partner10": "State Agency for Child Protection",
						"partner11": "Travel agency \"Blue Breeze Travel\"",
						"partner12": "Legal advisor real estate Martina Petkova",
						"partner13": "VIT - mattress exchange",
						"partner14": "Organizational system of accounting company AVM Consulting Group",
						"partner15": "API integration for Cyberkidz Patrol mobile app",
						"partner16": "Mr. Senkov Ltd - construction repairs and finishing works",
						"reviews": "Reviews",
						"errEmail": "Invalid email address!",
						"errInquire": "The query must be at least 10 characters long!",
						"makeAnInquiry": "make an inquiry",
						"static": "static website",
						"noStatic": "dynamic website",
						"to5": "to 5 pages",
						"to15": "to 15 pages",
						"unlimited": "unlimited number of pages",
						"oneLanguage": "only one language version",
						"multiLanguage": "possibility of multiple language versions",
						"seo": "SEO optimization",
						"ssl": "SSL certificate",
						"managament": "admin module for partial content management",
						"fullManagament": "admin module for content management",
						"name1": "Orlin Mateev",
						"name2": "Stoyanka Stoitchkova",
						"position1": "co-founder & ceo",
						"position2": "project menager",
						"sentSuccess": "The request was sent successfully!"
					}
				};
